"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_EVENTS_MAP = exports.TRANSACTION_EVENTS = void 0;
exports.TRANSACTION_EVENTS = [
    'txSent',
    'txConfirmed',
    'txFailed',
    'txError',
];
exports.TRANSACTION_EVENTS_MAP = Object.fromEntries(exports.TRANSACTION_EVENTS.map((event) => [event, event]));
